import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useTcrPartners(): UseAxiosResult<object> {
  return useAxios<object>({
    url: 'tcr-enums/partners',
    method: 'GET'
  });
}
